import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import { withLogFirehoseConsumer } from '../../context/devLogFirehose';
import withIsFocused from '../../decorators/withIsFocused';
import withRefreshControl from '../../decorators/withRefreshControl';
import {
  logAnalyticsEvent,
  logImpressionBatch,
} from '../../redux/actions/analyticsLog';
import { getMemberProfileActions } from '../../redux/actions/getMemberProfileActions';
import { getPromotionalThemesActions } from '../../redux/actions/getPromotionalThemesActions';
import { getRecommendProductsActions } from '../../redux/actions/getRecommendProductsActions';
import { getTopKeywordsActions } from '../../redux/actions/getTopKeywordsActions';
import { makeIsFetchingAboutWholeHome } from '../../redux/selectors/homepageSelector';
import { makeIsLogin } from '../../redux/selectors/member';
import { makePromoteItems } from '../../redux/selectors/promotionalThemesSelector';
import {
  getRecommendProductsDataByKey,
  makeRecommendProducts,
} from '../../redux/selectors/recommendProductsSelector';
import HomePage from './HomePage';

const mapStateToProps = () => {
  const selector = createStructuredSelector({
    // withRefreshControl 需要 isFetching
    isFetching: makeIsFetchingAboutWholeHome(true),
    isFetchingRecommendProducts: getRecommendProductsDataByKey(
      'isFetchingRecommendProducts',
      true
    ),
    hasMoreRecommendProducts: getRecommendProductsDataByKey(
      'hasMoreItems',
      true
    ),
    page: getRecommendProductsDataByKey('page'),
    recommendProducts: makeRecommendProducts(),
    isLogin: makeIsLogin(),
    promoteItems: makePromoteItems(),
  });

  return state => selector(state);
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getMemberProfile: getMemberProfileActions.request,
      getPromoteItems: getPromotionalThemesActions.request,
      getRecommendProducts: getRecommendProductsActions.request,
      getTopKeyWords: getTopKeywordsActions.request,
      logEvent: logAnalyticsEvent,
      logImpressionBatch,
    },
    dispatch
  );
};

const enhance = compose(
  withRefreshControl,
  withLogFirehoseConsumer,
  withIsFocused
);

export default connect(mapStateToProps, mapDispatchToProps)(enhance(HomePage));
